<div class="app-page">
  <!-- Header -->
  <div class="app-page-header">
    <div class="flex items-center justify-between">
      <div>
        <h1 class="section-title">{{ isEditMode() ? 'Editar Tipo de Material' : 'Nuevo Tipo de Material' }}</h1>
        <p class="section-subtitle">
          {{ isEditMode() ? 'Modifica la información del tipo de material' : 'Completa los datos para crear un nuevo tipo de material' }}
        </p>
      </div>
      <div class="flex gap-2">
        <button
          pButton
          type="button"
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-outlined"
          (click)="onCancel()"
          [disabled]="loading()">
        </button>
        <button
          pButton
          type="button"
          [label]="isEditMode() ? 'Guardar Cambios' : 'Crear Tipo Material'"
          [icon]="isEditMode() ? 'pi pi-check' : 'pi pi-plus'"
          class="p-button"
          (click)="onSubmit()"
          [disabled]="loading() || tipoMaterialForm.invalid"
          [loading]="loading()">
        </button>
      </div>
    </div>
  </div>

  <!-- Main Content -->
  <div class="app-page-content">
    <form [formGroup]="tipoMaterialForm" (ngSubmit)="onSubmit()" id="tipoMaterialForm">
      <div class="app-card">
        <!-- Form Title -->
        <h2 class="text-xl font-semibold mb-6" style="color: hsl(var(--text));">
          {{ isEditMode() ? 'Datos del Tipo de Material' : 'Datos Generales' }}
        </h2>

        <div class="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          <!-- Código -->
          <div class="space-y-2">
            <label for="codigo" class="text-sm font-medium" style="color: hsl(var(--text));">
              Código *
            </label>
            <input
              pInputText
              id="codigo"
              formControlName="codigo"
              type="text"
              placeholder="Ej: AVISO30"
              class="w-full"
              [class.border-red-500]="tipoMaterialForm.get('codigo')?.invalid && tipoMaterialForm.get('codigo')?.touched"
            />
            @if (tipoMaterialForm.get('codigo')?.hasError('required') && tipoMaterialForm.get('codigo')?.touched) {
              <small class="text-sm block" style="color: hsl(var(--danger));">
                Código es requerido
              </small>
            }
            @if (tipoMaterialForm.get('codigo')?.hasError('maxlength')) {
              <small class="text-sm block" style="color: hsl(var(--danger));">
                Código no puede exceder 255 caracteres
              </small>
            }
            @if (tipoMaterialForm.get('codigo')?.hasError('server')) {
              <small class="text-sm block" style="color: hsl(var(--danger));">
                {{ tipoMaterialForm.get('codigo')?.getError('server') }}
              </small>
            }
          </div>

          <!-- Nombre -->
          <div class="space-y-2">
            <label for="nombre" class="text-sm font-medium" style="color: hsl(var(--text));">
              Nombre *
            </label>
            <input
              pInputText
              id="nombre"
              formControlName="nombre"
              type="text"
              placeholder="Ej: Aviso 30 segundos"
              class="w-full"
              [class.border-red-500]="tipoMaterialForm.get('nombre')?.invalid && tipoMaterialForm.get('nombre')?.touched"
            />
            @if (tipoMaterialForm.get('nombre')?.hasError('required') && tipoMaterialForm.get('nombre')?.touched) {
              <small class="text-sm block" style="color: hsl(var(--danger));">
                Nombre es requerido
              </small>
            }
            @if (tipoMaterialForm.get('nombre')?.hasError('maxlength')) {
              <small class="text-sm block" style="color: hsl(var(--danger));">
                Nombre no puede exceder 255 caracteres
              </small>
            }
            @if (tipoMaterialForm.get('nombre')?.hasError('server')) {
              <small class="text-sm block" style="color: hsl(var(--danger));">
                {{ tipoMaterialForm.get('nombre')?.getError('server') }}
              </small>
            }
          </div>

          <!-- Factor Precio -->
          <div class="space-y-2">
            <label for="factorPrecio" class="text-sm font-medium" style="color: hsl(var(--text));">
              Factor Precio *
            </label>
            <p-inputNumber
              inputId="factorPrecio"
              formControlName="factorPrecio"
              mode="decimal"
              [minFractionDigits]="2"
              [maxFractionDigits]="2"
              [min]="0"
              placeholder="0.00"
              styleClass="w-full"
              inputStyleClass="w-full"
              [class.border-red-500]="tipoMaterialForm.get('factorPrecio')?.invalid && tipoMaterialForm.get('factorPrecio')?.touched">
            </p-inputNumber>
            @if (tipoMaterialForm.get('factorPrecio')?.hasError('required') && tipoMaterialForm.get('factorPrecio')?.touched) {
              <small class="text-sm block" style="color: hsl(var(--danger));">
                Factor Precio es requerido
              </small>
            }
            @if (tipoMaterialForm.get('factorPrecio')?.hasError('min')) {
              <small class="text-sm block" style="color: hsl(var(--danger));">
                Factor Precio debe ser mayor o igual a 0
              </small>
            }
            @if (tipoMaterialForm.get('factorPrecio')?.hasError('server')) {
              <small class="text-sm block" style="color: hsl(var(--danger));">
                {{ tipoMaterialForm.get('factorPrecio')?.getError('server') }}
              </small>
            }
          </div>

          <!-- Aplica a Tanda -->
          <div class="space-y-2">
            <div class="flex items-center justify-between p-4 rounded-lg" style="background-color: hsl(var(--surface-2));">
              <div>
                <label for="aplicaATanda" class="text-sm font-medium" style="color: hsl(var(--text));">
                  Aplica a Tanda
                </label>
                <p class="text-sm text-muted mt-1">
                  Indica si este tipo se aplica a tandas
                </p>
              </div>
              <p-toggleSwitch
                id="aplicaATanda"
                formControlName="aplicaATanda">
              </p-toggleSwitch>
            </div>
          </div>

          <!-- Es No Tradicional -->
          <div class="space-y-2">
            <div class="flex items-center justify-between p-4 rounded-lg" style="background-color: hsl(var(--surface-2));">
              <div>
                <label for="esNoTradicional" class="text-sm font-medium" style="color: hsl(var(--text));">
                  Es No Tradicional
                </label>
                <p class="text-sm text-muted mt-1">
                  Marca si es material no tradicional
                </p>
              </div>
              <p-toggleSwitch
                id="esNoTradicional"
                formControlName="esNoTradicional">
              </p-toggleSwitch>
            </div>
          </div>

          <!-- Estado Activo -->
          <div class="space-y-2 md:col-span-2 lg:col-span-3">
            <div class="flex items-center justify-between p-4 rounded-lg" style="background-color: hsl(var(--surface-2));">
              <div>
                <label for="active" class="text-sm font-medium" style="color: hsl(var(--text));">
                  Tipo de Material Activo
                </label>
                <p class="text-sm text-muted mt-1">
                  Indica si el tipo de material está active en el sistema
                </p>
              </div>
              <p-toggleSwitch
                id="active"
                formControlName="active">
              </p-toggleSwitch>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
